import { render, staticRenderFns } from "./TownsStreetsMonthServiceElderSubsidy.vue?vue&type=template&id=2a03977c&scoped=true&"
import script from "./TownsStreetsMonthServiceElderSubsidy.vue?vue&type=script&lang=js&"
export * from "./TownsStreetsMonthServiceElderSubsidy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a03977c",
  null
  
)

export default component.exports